import { render } from "./SortByModal.vue?vue&type=template&id=84edb7c0"
import script from "./SortByModal.vue?vue&type=script&lang=js"
export * from "./SortByModal.vue?vue&type=script&lang=js"

import "./SortByModal.vue?vue&type=style&index=0&id=84edb7c0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__